const initialState = () => ({
  loading: false,
  visitDetail: null
});

const ACTION_KEY = 'LINK_PROFESSIONAL_VISIT_DETAIL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const visitDetail = action.payload;

      return {
        ...state,
        visitDetail,
        loading: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
